import script from "./TableComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./TableComponent.vue?vue&type=script&setup=true&lang=js"

import "./TableComponent.vue?vue&type=style&index=0&id=562e8105&scoped=true&lang=scss"

import exportComponent from "D:\\liu\\jmzc\\jimuERPVUE\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-562e8105"]])

export default __exports__